/* eslint-disable operator-linebreak */
import Util from '@/assets/libs/util'

let showMinPriceDifference
let minPrecMutexGroups
let minPrecComboCombo
let priceMounted

const getMinPrice = function (prod) {
  const alreadyCalculatedMinPrice = prod.calculatedMinPrice != null

  if (alreadyCalculatedMinPrice) {
    return prod.calculatedMinPrice
  } else {
    return calculateMinPrice(prod)
  }
}

const calculateMinPrice = function (prod) {
  initGlobalVariables()

  const isComboProduct = prod.productGroups && prod.productGroups.length > 0
  const productPrint = prod.productPrint === 'S'
  if (!isComboProduct || productPrint) {
    priceMounted += prod.price
  }

  const productHasGroups = prod.productGroups && prod.productGroups.length > 0
  if (productHasGroups) {
    treatGroupsMinPrices(prod)
    treatMutexGroupsMinPrices(prod)
  }

  prod.calculatedMinPrice = priceMounted
  return priceMounted
}

const initGlobalVariables = function () {
  showMinPriceDifference = true // Util.getLocalConfigs('showMinPriceDifference')
  minPrecMutexGroups = {}
  minPrecComboCombo = {}
  priceMounted = 0
}

const treatGroupsMinPrices = function (prod) {
  prod.productGroups.forEach(group => {
    const firstLevelFatherPrint = prod.productPrint === 'S'
    const groupPrint = group.productGroupPrint === 'S'
    const mandatoryGroup = group.productGroupMin > 0
    let minPrecSubItem = null

    if ((groupPrint && mandatoryGroup) || !firstLevelFatherPrint) {
      minPrecSubItem = getGroupMinPriceItem(group, prod.productCode, firstLevelFatherPrint)
    }

    if (minPrecSubItem) {
      const isMutexGroup = group.productGroupMutex != null
      if (isMutexGroup) {
        insertPriceInMutexObject(group, minPrecSubItem)
      } else {
        priceMounted += minPrecSubItem.price * group.productGroupMin
        if (showMinPriceDifference) {
          insertGroupMinPrice(group, minPrecSubItem.price)
        }
      }
    }

    checkForComboDoComboMinPrices(prod, group, firstLevelFatherPrint)
    pickMinPriceFromAllComboDoCombo(group, prod)
  })
}

const getGroupMinPriceItem = function (group, fatherProductCode, fatherPrint) {
  const groupHasItems = group && group.productGroupItems && group.productGroupItems.length > 0
  const groupItems = groupHasItems ? group.productGroupItems : []
  const filteredGroupItems = Util.removeBlockedProds(groupItems)
  let minPriceItem = null

  if (filteredGroupItems.length > 0) {
    minPriceItem = filteredGroupItems.reduce((a, b) => {
      if (b.price < a.price) a = b
      return a
    })
  }

  if (minPriceItem) {
    const isFosException = Util.isFosException(minPriceItem, fatherProductCode, fatherPrint, group.productGroupPrint)
    if (isFosException) {
      minPriceItem = null
    }
  }

  return minPriceItem
}

const insertPriceInMutexObject = function (group, minPrecSubItem) {
  if (minPrecMutexGroups[group.productGroupMutex]) {
    minPrecMutexGroups[group.productGroupMutex].push(minPrecSubItem.price * group.productGroupMin)
  } else {
    minPrecMutexGroups[group.productGroupMutex] = []
    minPrecMutexGroups[group.productGroupMutex].push(minPrecSubItem.price * group.productGroupMin)
  }
}

const insertGroupMinPrice = function (group, minPrice) {
  // Se o grupo contiver produtos simples e outros que são combo do combo, esse preço minimo
  // não considera os itens filhos do combo do combo, apenas o preço do principal. Se necessário
  // utilizar os preços de dentro do combo do combo, o reduce usado para encontrar o minPrecSubItem
  // terá que ser transformado em um forEach, para dentro dele calcular de uma forma para
  // produtos simples e de outra para combo do combo (essa lógica considera os produtos do nível 2)
  group.minPrice = minPrice
}

const checkForComboDoComboMinPrices = function (prod, group, firstLevelFatherPrint) {
  // A segunda verificação é uma solução temporária para os produtos chegando errado no cardápio, trazendo o
  // produto inteiro dentro do primeiro subgrupo. Remover assim que o problema for corrigido na Interface
  const groupHasItems = group.productGroupItems && group.productGroupItems.length > 0
  const isNotInterfaceError = group.productGroupName !== prod.productName

  if (groupHasItems && isNotInterfaceError) {
    const filteredItems = Util.removeBlockedProds(group.productGroupItems)

    filteredItems.forEach(subProd => {
      const comboDoCombo = Util.isComboDoCombo(subProd, prod.productCode)
      if (comboDoCombo) {
        getComboDoComboMinPrices(subProd, firstLevelFatherPrint, group)
      }
    })
  }
}

const getComboDoComboMinPrices = function (subProd, firstLevelFatherPrint, group) {
  subProd.subItemProductGroups.forEach(subGroup => {
    let minPrecSubSubItem

    if (subGroup.subProductGroupMin > 0 && (subGroup.subProductGroupPrint === 'S' || !firstLevelFatherPrint)) {
      minPrecSubSubItem = getSubGroupMinPriceItem(subGroup)
    }

    if (minPrecSubSubItem) {
      const isMutexGroup = subGroup.subProductGroupMutex != null
      if (isMutexGroup) {
        minPrecSubSubItem.groupMutexInfo = {
          mutexKey: subGroup.subProductGroupMutex,
          groupName: group.productGroupName,
          subProdName: subProd.subItemName
        }
      }

      insertProdInComboDoComboObject(subProd, minPrecSubSubItem)
      if (showMinPriceDifference) {
        insertGroupMinPrice(subGroup, minPrecSubSubItem.price)
      }
    }
  })
}

const getSubGroupMinPriceItem = function (subGroup) {
  const subGroupHasItems = subGroup && subGroup.subProductGroupItems && subGroup.subProductGroupItems.length > 0
  const subGroupItems = subGroupHasItems ? subGroup.subProductGroupItems : []
  const filteredSubGroupItems = Util.removeBlockedProds(subGroupItems)

  if (filteredSubGroupItems.length > 0) {
    return filteredSubGroupItems.reduce((a, b) => {
      if (b.price < a.price) a = b
      return a
    })
  } else {
    return null
  }
}

const insertProdInComboDoComboObject = function (subProd, minPrecSubSubItem) {
  if (minPrecComboCombo[subProd.subItemCode]) {
    minPrecComboCombo[subProd.subItemCode].push(minPrecSubSubItem)
  } else {
    minPrecComboCombo[subProd.subItemCode] = []
    minPrecComboCombo[subProd.subItemCode].push(minPrecSubSubItem)
  }
}

const pickMinPriceFromAllComboDoCombo = function (group, prod) {
  let comboDoComboMinPrice = null
  const keys = Object.keys(minPrecComboCombo)

  keys.forEach(key => {
    const mutexGroupsMinPrices = {}
    let curMinPrice = 0

    minPrecComboCombo[key].forEach(prod => {
      const prodIsFromMutexGroup = prod.groupMutexInfo && prod.groupMutexInfo.mutexKey != null
      if (prodIsFromMutexGroup) {
        insertIntoMutexObject(mutexGroupsMinPrices, prod)
      } else {
        curMinPrice += prod.price
      }
    })

    if (mutexGroupsMinPrices !== {}) {
      curMinPrice += getMinPricesFromMutexGroups(mutexGroupsMinPrices, prod)
    }

    if (!comboDoComboMinPrice) {
      comboDoComboMinPrice = curMinPrice
    } else if (curMinPrice < comboDoComboMinPrice) {
      comboDoComboMinPrice = curMinPrice
    }
  })

  if (comboDoComboMinPrice) {
    priceMounted += comboDoComboMinPrice * group.productGroupMin
  }

  minPrecComboCombo = {}
}

const insertIntoMutexObject = function (mutexGroupsMinPrices, prod) {
  if (mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey]) {
    mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey].push(prod)
  } else {
    mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey] = []
    mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey].push(prod)
  }
}

const getMinPricesFromMutexGroups = function (mutexGroupsMinPrices, prod) {
  let mutexMinPrices = 0
  const mutexKeys = Object.keys(mutexGroupsMinPrices)

  mutexKeys.forEach(mutexKey => {
    const currentMutexGroup = mutexGroupsMinPrices[mutexKey]
    let currentMutexMinPriceProd = null

    currentMutexGroup.forEach(prod => {
      if (!currentMutexMinPriceProd) {
        currentMutexMinPriceProd = prod
      } else if (prod.price < currentMutexMinPriceProd.price) {
        currentMutexMinPriceProd = prod
      }
    })

    if (currentMutexMinPriceProd) {
      mutexMinPrices += currentMutexMinPriceProd.price
    }

    if (showMinPriceDifference) {
      setComboDoComboMutexMinPrice(currentMutexMinPriceProd, prod)
    }
  })

  return mutexMinPrices
}

const setComboDoComboMutexMinPrice = function (mutexMinPriceProd, prod) {
  try {
    const mutexMinPrice = mutexMinPriceProd.price
    const groupMutexInfo = mutexMinPriceProd.groupMutexInfo
    let subProdToApplyMinMutexPrice = null
    const groupToSearch = prod.productGroups.find(group => group.productGroupName === groupMutexInfo.groupName)
    const hasItems = groupToSearch && groupToSearch.productGroupItems != null

    if (hasItems) {
      subProdToApplyMinMutexPrice = groupToSearch.productGroupItems.find(subProd => subProd.subItemName === groupMutexInfo.subProdName)
    }

    const hasSubGroups = subProdToApplyMinMutexPrice && subProdToApplyMinMutexPrice.subItemProductGroups
            && subProdToApplyMinMutexPrice.subItemProductGroups.length > 0

    if (hasSubGroups) {
      subProdToApplyMinMutexPrice.subItemProductGroups.forEach(subGroup => {
        if (subGroup.subProductGroupMutex === groupMutexInfo.mutexKey) {
          subGroup.minPrice = mutexMinPrice
        }
      })
    }
  } catch (error) {
    console.log(error.message)
    Util.logComunication('Exception ', {}, error.message)
  }
}

const treatMutexGroupsMinPrices = function (prod) {
  const mutexKeys = Object.keys(minPrecMutexGroups)
  if (mutexKeys.length > 0) {
    mutexKeys.forEach(key => {
      const currentMutexGroup = minPrecMutexGroups[key]
      let currentMutexMinPrice

      currentMutexGroup.forEach((price, index) => {
        if (index === 0) {
          currentMutexMinPrice = price
        } else if (price < currentMutexMinPrice) {
          currentMutexMinPrice = price
        }
      })
      priceMounted += currentMutexMinPrice
      if (showMinPriceDifference) {
        setMutexGroupsMinPrice(prod, key, currentMutexMinPrice)
      }
    })
  }
}

const setMutexGroupsMinPrice = function (prod, mutexKey, mutexMinPrice) {
  const groups = prod.productGroups || []
  groups.forEach(group => {
    const isSameMutex = group.productGroupMutex && group.productGroupMutex === mutexKey
    if (isSameMutex) {
      const productGroupMin = group.productGroupMin || 1
      group.minPrice = mutexMinPrice / productGroupMin
    }
  })
}

export default {
  getMinPrice: getMinPrice
}
